var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0612 7.85399C18.9219 7.7146 18.7565 7.60402 18.5745 7.52858C18.3924 7.45314 18.1973 7.41431 18.0002 7.41431C17.8032 7.41431 17.608 7.45314 17.426 7.52858C17.2439 7.60402 17.0785 7.7146 16.9392 7.85399L12.3532 12.439C12.2595 12.5327 12.1323 12.5854 11.9997 12.5854C11.8671 12.5854 11.74 12.5327 11.6462 12.439L7.06122 7.85399C6.77996 7.57259 6.39843 7.41445 6.00057 7.41436C5.60271 7.41427 5.22111 7.57222 4.93972 7.85349C4.65832 8.13475 4.50019 8.51627 4.50009 8.91413C4.5 9.31199 4.65796 9.69359 4.93922 9.97499L9.52522 14.561C9.85023 14.886 10.2361 15.1439 10.6607 15.3198C11.0854 15.4957 11.5406 15.5862 12.0002 15.5862C12.4599 15.5862 12.915 15.4957 13.3397 15.3198C13.7644 15.1439 14.1502 14.886 14.4752 14.561L19.0612 9.97499C19.3424 9.6937 19.5004 9.31223 19.5004 8.91449C19.5004 8.51674 19.3424 8.13528 19.0612 7.85399Z",
    fill: "#0076BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.f9629e1a80043e47b55583b698850223.svg";
export { ForwardRef as ReactComponent };